import { render } from "./ConfigurationHeader.vue?vue&type=template&id=fab8a6a4"
import script from "./ConfigurationHeader.vue?vue&type=script&lang=js"
export * from "./ConfigurationHeader.vue?vue&type=script&lang=js"

import "./ConfigurationHeader.vue?vue&type=style&index=0&id=fab8a6a4&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__